import { useCallback } from "react"
import { useAuthContext } from "../contexts/AuthContext"
import { useApiAuthCheck } from "./useApiAuthCheck"
import useLocalStorage from "./useLocalStorage"
import { 
    destroyNotificaciones,
    indexNotificaciones, updateLeerNotificacion, 
    updateLeerNotificaciones
} from "../utils/api/api.notificaciones"

const useNotificaciones = () => {

    const { token } = useAuthContext()
    const { callApiWithAuth } = useApiAuthCheck()

    const [notifs, setNotifs] = useLocalStorage('notificaciones')

    const fillData = useCallback((ret) => {  
        if(ret?.code === 200){
            const newData = ret.notificaciones
            if(JSON.stringify(notifs) !== JSON.stringify(newData)){
                setNotifs(newData)
            }
        }
    },[notifs,setNotifs])

    const indexNotificacionesHook = useCallback(async() => {
        const ret = await callApiWithAuth(
            () => indexNotificaciones(token)
        )
        fillData(ret)
        return ret
    },[callApiWithAuth, token, fillData ])

    const updateLeerNotificacionHook = useCallback(async(id) => {
        const ret = await callApiWithAuth(
            () => updateLeerNotificacion(token, id)
        )
        fillData(ret)
        return ret
    },[callApiWithAuth, token, fillData ])

    const updateLeerNotificacionesHook = useCallback(async() => {
        const ret = await callApiWithAuth(
            () => updateLeerNotificaciones(token)
        )
        fillData(ret)
        return ret
    },[callApiWithAuth, token, fillData ])

    const destroyNotificacionesHook = useCallback(async() => {
        const ret = await callApiWithAuth(
            () => destroyNotificaciones(token)
        )
        fillData(ret)
        return ret
    },[callApiWithAuth, token, fillData ])

    return {
        notifs, 
        indexNotificacionesHook, updateLeerNotificacionHook, 
        updateLeerNotificacionesHook, destroyNotificacionesHook
    }
}

export { useNotificaciones }
